<div
  class="marker"
  [class.icon]="isResolved()"
  [class.is-arrival]="isArrival()"
>
  @if (!isResolved()) {
    <onyx-dot color="light-black"></onyx-dot>
  } @else {
    <onyx-icon
      [class]="color()"
      name="check-circle-filled"
      [size]="16"
    ></onyx-icon>
  }
</div>

<div class="content">
  <div class="row {{ color() }}">
    {{ labels().label | translate }}

    @if (!isResolved() && !isCanceled()) {
      @if (estimatedTime(); as time) {
        <div class="wrapper">
          <span [onyxTooltip]="labels().tooltip">
            {{ labels().estimationLabel | translate }}
          </span>

          {{ time | onyxDate: 'time-date-dot' : { separator: ' · ' } }}
        </div>
      } @else {
        <span>{{ labels().unknownLabel | translate }}</span>
      }
    } @else if (timestamp(); as time) {
      <div class="wrapper">
        @if (isManual()) {
          <onyx-icon
            class="f-muted"
            name="manual-outlined"
            [size]="12"
            [onyxTooltip]="`${I18N}.manualStatusHint`"
          ></onyx-icon>
        }

        <span>
          {{ time | onyxDate: 'time-date-dot' : { separator: ' · ' } }}
        </span>
      </div>
    } @else {
      <span class="wrapper">-</span>
    }
  </div>

  @if (hasPointDeadline()) {
    <app-route-point-time-windows
      [value]="value()"
      variant="expanded"
      [color]="color()"
    ></app-route-point-time-windows>
  } @else if (!isCanceled()) {
    <div class="row f-body-xs f-muted">
      {{ `${I18N}.missingPointDepartureDeadline` | translate }}
    </div>
  }

  @if (!isCanceled()) {
    @if (waitingForServiceDurationWarning(); as duration) {
      <div class="row f-body-xs f-muted">
        <div class="wrapper">
          <onyx-icon name="alert-two-tone-filled" [size]="12"></onyx-icon>

          <span
            class="dotted"
            onyxTooltip="route.waitingForServiceDurationWarning"
          >
            {{ `${I18N}.inefficientPlanning` | translate }}
          </span>
        </div>

        +{{ duration | duration }}
      </div>
    }

    <div class="row f-body-xs f-muted" [class.f-danger]="hasTermConflict()">
      @if (
        (isResolved() ? timestamp() : estimatedTime()) && chainDeadline();
        as deadline
      ) {
        <div class="wrapper">
          @if (hasTermConflict()) {
            <onyx-icon name="error-filled" [size]="12"></onyx-icon>
          }

          <span
            [class.dotted]="hasTermConflict()"
            [class.red]="hasTermConflict()"
            [onyxTooltip]="`${I18N}.termConflictTooltip`"
            [onyxTooltipDisabled]="!hasTermConflict()"
          >
            {{ `${I18N}.chainDeadline` | translate }}
          </span>
        </div>

        {{ deadline | onyxDate: 'time-date-dot' : { separator: ' · ' } }}
      } @else {
        <span>
          {{ `${I18N}.missingChainDeadline` | translate }}
        </span>
      }
    </div>
  }
</div>
